export class CoolerStyleFilter {
    public IncludeInactive?: boolean;
}

export default CoolerStyleFilter;